import { useFormContext } from "react-hook-form";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import FieldBlock from "./FieldBlock";
import FieldHint from "./FieldHint";
import FieldLabel from "./FieldLabel";
import { getVisibleFormErrorsForField } from "../preActivationVisibleErrors";

const TextFieldBlock = ({
  name,
  label,
  placeholder,
  hint,
  required = false,
  showLabel = true,
  control,
  errors,
  readOnly,
  type = "text",
  multiline = false,
  minRows,
  inputProps,
}) => {
  const { formState, trigger } = useFormContext();
  const visibleErrors = getVisibleFormErrorsForField({
    errors,
    name,
    formState,
  });
  const validateField = () => {
    if (readOnly) return;
    trigger(name);
  };

  return (
    <FieldBlock>
      {showLabel ? (
        <FieldLabel htmlFor={name} text={label} required={required} />
      ) : null}
      {hint ? <FieldHint text={hint} /> : null}
      <IntakeTextField
        name={name}
        control={control}
        rules={{}}
        errors={visibleErrors}
        fullWidth
        readOnly={readOnly}
        placeholder={placeholder}
        variant="outlined"
        type={type}
        multiline={multiline}
        minRows={minRows}
        actionsChange={validateField}
        actionsBlur={validateField}
        inputProps={{
          ...inputProps,
          ...(showLabel ? {} : { "aria-label": label }),
        }}
      />
    </FieldBlock>
  );
};

export default TextFieldBlock;
